<script>
    import { createEventDispatcher } from 'svelte';
    export let totalElements, entries, currentPage;
    let pages = [];

    const dispatch = createEventDispatcher();

    let changePage = function(page){
        currentPage = page;
        dispatch('change', { page: currentPage });
    }

    function getPages(){
        pages = [];
        for(let pageNumber = 0; pageNumber < (parseInt(totalElements/entries)); pageNumber++){
            pages.push(pageNumber);
        }
        if(totalElements%entries > 0){
            pages.push(parseInt(totalElements/entries));
        }
    }

    $: getPages( totalElements, entries);

</script>

{#if pages.length > 1}
    <div class="row">
        <div class="col-md-12 text-center">
            <nav aria-label="Page navigation example">
                <ul class="pagination">
                     <li on:click={changePage(currentPage-1)} class="page-item {(currentPage == 0)?'disabled not-clickable':''}"><button class="page-link">Previous</button></li>
                    {#each pages as page}
                        <li on:click={changePage(page)} class="page-item"><button class="page-link">{ page +1 }</button></li>
                    {/each}
                    <li on:click={changePage(currentPage+1)} class="page-item {(currentPage == pages.length-1)?'disabled not-clickable':''}"><button class="page-link">Next</button></li>
                </ul>
            </nav>
        </div>
    </div>
{/if}
